var exports = {};

var PREENTERIEWPORT = 'preEnterViewport';
var PREEXITVIEWPORT = 'preExitViewport';
var ENTERVIEWPORT = 'enterViewport';
var EXITVIEWPORT = 'exitViewport';

var eventTypes = [
	PREENTERIEWPORT,
	PREEXITVIEWPORT,
	ENTERVIEWPORT,
	EXITVIEWPORT
];

var watchers = new WeakMap();

var preenterObserver = new IntersectionObserver(
	function(entries) {
		entries.forEach(function(entry) {
			watchers.get(entry.target).triggerCallbacks(entry.isIntersecting ? PREENTERIEWPORT : PREEXITVIEWPORT);
		});
	}, {
		rootMargin: '50% 0px 50% 0px',
		threshold: [0.0001]
	}
);

var enterExitObserver = new IntersectionObserver(
	function(entries) {
		entries.forEach(function(entry) {
			watchers.get(entry.target).triggerCallbacks(entry.isIntersecting ? ENTERVIEWPORT : EXITVIEWPORT);
		});
	}, {
		threshold: [0.0001]
	}
);

function ElementWatcher( watchItem ) {
	var self = this;

	this.watchItem = watchItem;

	this.callbacks = {}; // {callback: function, isOne: true }

	for (var i = 0, j = eventTypes.length; i < j; i++) {
		self.callbacks[eventTypes[i]] = [];
	}

	watchers.set(watchItem, this);
	preenterObserver.observe(watchItem);
	enterExitObserver.observe(watchItem);

	var listenerToTriggerListI;
	var listener;

	this.latestPreEvent = null;
	this.latestEvent = null;

	function triggerCallbackArray( listeners, event ) {
		if (listeners.length === 0) {
			return;
		}
		listenerToTriggerListI = listeners.length;
		while( listenerToTriggerListI-- ) {
			listener = listeners[listenerToTriggerListI];
			listener.callback.call( self, event );
			if (listener.isOne) {
				listeners.splice(listenerToTriggerListI, 1);
			}
		}
	}

	this.isInPreViewport = null;
	this.isInViewport = null;
	this.triggerCallbacks = function triggerCallbacks(event) {
		if (this.isInPreViewport && event === PREEXITVIEWPORT) {
			this.isInPreViewport = false;
			triggerCallbackArray(this.callbacks[PREEXITVIEWPORT], event);
		} else if (!this.isInPreViewport && event === PREENTERIEWPORT) {
			this.isInPreViewport = true;
			triggerCallbackArray(this.callbacks[PREENTERIEWPORT], event);
		} else if (this.isInPreViewport === null) {
			this.isInPreViewport = false;
		}

		if (this.isInViewport && event === EXITVIEWPORT) {
			this.isInViewport = false;
			triggerCallbackArray( this.callbacks[EXITVIEWPORT] );
		} else if (!this.isInViewport && event === ENTERVIEWPORT) {
			this.isInViewport = true;
			triggerCallbackArray(this.callbacks[ENTERVIEWPORT], event);
		} else if (this.isInViewport === null) {
			this.isInViewport = false;
		}

		if (event === PREEXITVIEWPORT || event === PREENTERIEWPORT) {
			this.latestPreEvent = event;
		} else {
			this.latestEvent = event;
		}
	};
}

ElementWatcher.prototype = {
	on: function( event, callback, isOne ) {

		// trigger the event if it applies to the element right now.
		switch( true ) {
			case event === PREENTERIEWPORT && this.isInPreViewport === true:
			case event === PREEXITVIEWPORT && this.isInPreViewport === false:
				callback.call( this, this.latestPreEvent );
				if (isOne) {
					return;
				}
				break;
			case event === ENTERVIEWPORT && this.isInViewport === true:
			case event === EXITVIEWPORT && this.isInViewport === false:
				callback.call( this, this.latestEvent );
				if (isOne) {
					return;
				}
				break;
		}

		if (this.callbacks[event]) {
			this.callbacks[event].push({callback: callback, isOne: isOne||false});
		} else {
			throw new Error('Tried to add a scroll monitor listener of type '+event+'. Your options are: '+eventTypes.join(', '));
		}
	},
	off: function( event, callback ) {
		if (this.callbacks[event]) {
			for (var i = 0, item; item = this.callbacks[event][i]; i++) {
				if (item.callback === callback) {
					this.callbacks[event].splice(i, 1);
					break;
				}
			}
		} else {
			throw new Error('Tried to remove a scroll monitor listener of type '+event+'. Your options are: '+eventTypes.join(', '));
		}
	},
	one: function( event, callback ) {
		this.on( event, callback, true);
	},
	destroy: function() {
		preenterObserver.unobserve(this.watchItem);
		enterExitObserver.unobserve(this.watchItem);
	}
};

exports.create = function( element, offsets ) {
	if (typeof element === 'string') {
		element = document.querySelector(element);
	} else if (element && element.length > 0) {
		element = element[0];
	}
	return new ElementWatcher( element, offsets );
};

export default exports;
